// extracted by mini-css-extract-plugin
module.exports = {"AlarmToHandleHeader":"AlarmToHandleHeader_AlarmToHandleHeader__5fomV"};